const axios = require('axios');
const moment = require('moment');

import { EventBus, globalEvents } from '@/event-bus/event-bus.js';


export default {
    getApi() {
        return axios.create({
            baseURL: process.env.VUE_APP_JOBS_API_ROOT,
            headers: { Authorization: `Bearer ${localStorage.backendToken}` }
        })
    },
    tokenValidForUnits (api, token, unitIds, callback, errorCallback) {
        api.get("units", {params: {token: token}}).then(function (response) {
            let tokenUnitIds = new Set(response.data.units.map(unit => unit.id));
            let missingUnits = unitIds.filter(x => !tokenUnitIds.has(x));

            if (missingUnits.length > 0) {
                // The token is not valid for all the given units
                callback(false);
            } else {
                callback(true);
            }
        }).catch(errorCallback)
    },
    getCurrentUser (callback, errorCallback) {
        this.getApi().get("me").then(function (response) {
            callback(response.data);
        }).catch(errorCallback)
    },
    getAccessToken () {
        let wialonURL = "https://hosting.wialon.com";

        // https://sdk.wialon.com/wiki/en/sidebar/remoteapi/apiref/login/login
        let url = wialonURL + "/login.html";
        url += "?client_id=" + "trip-report";
        url += "&access_type=" + 0x100;	// access level, 0x100 = "Online tracking only"
        url += "&activation_time=" + 0;	// activation time, 0 = immediately
        url += "&duration=" + 0;	      // unlimited token
        url += "&flags=" + 0x1;			    // options, 0x1 = add username in response

        // Redirect to this page
        url += "&redirect_uri=" + wialonURL + "/post_token.html";

        // listen message with token from login page window
        window.addEventListener("message", this.tokenReceived);

        // finally, open login page in new window
        window.open(url, "_blank", "width=760, height=500, top=300, left=500");
    },
    tokenReceived (tokenRespose) {
        let data = tokenRespose.data;

        if (data.includes("token=")) {
            EventBus.$emit(
                globalEvents.wialonTokenUpdated,
                data.split("=")[1]
            );
        }
    },
    login (email, password, view, recaptchaToken) {
        if (recaptchaToken == null) {
            view.$buefy.toast.open({
                duration: 3000,
                message: view.$t("misc.invalidReCAPTCHA"),
                position: "is-top",
                type: "is-danger"
            });

            return;
        }

        let loginData = {
            email: email,
            password: password,
            recaptchaToken: recaptchaToken
        };

        axios.post(process.env.VUE_APP_JOBS_API_ROOT + "/login", loginData).then(function (response) {
            if (response.status == 200) {
                window.localStorage.backendToken = response.data.token;

                view.$router.push("/");
                view.$buefy.toast.open({
                    duration: 3000,
                    message: view.$t("login.success"),
                    position: "is-top",
                    type: "is-success"
                });
            } else {
                view.$buefy.toast.open({
                    duration: 3000,
                    message: view.$t("misc.genericError"),
                    position: "is-top",
                    type: "is-danger"
                })
            }
        }).catch(function () {
            view.$buefy.toast.open({
                duration: 3000,
                message: view.$t("login.invalidCredentials"),
                position: "is-top",
                type: "is-danger"
            })
        });
    },
    capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatDate (date) {
        return moment(date).format("DD/MM/YYYY");
    }
}